export default __webpack_public_path__ + "static/0296-a42ed7cc2d8fe5b4d7ec65bf3527e30f.png";